export default __webpack_public_path__ + "static/media/crypto-portfolio.99bdd772.svg";